
export const resolveDatePreset = preset => {
  const now = new Date();

  const startOfDay = date => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const endOfDay = date => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  };

  switch (preset) {
    case "today": {
      return {
        fromDate: startOfDay(now).getTime(),
        toDate: now.getTime()
      };
    }
    case "yesterday": {
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      return {
        fromDate: startOfDay(yesterday).getTime(),
        toDate: endOfDay(yesterday).getTime()
      };
    }
    case "lastWeek": {
      const day = now.getDay(); // 0=Sun
      const daysToLastMonday = day === 0 ? 6 : day - 1 + 7;
      const lastMonday = new Date(now);
      lastMonday.setDate(now.getDate() - daysToLastMonday);
      const lastSunday = new Date(lastMonday);
      lastSunday.setDate(lastMonday.getDate() + 6);
      return {
        fromDate: startOfDay(lastMonday).getTime(),
        toDate: endOfDay(lastSunday).getTime()
      };
    }
    case "thisMonth": {
      const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      return {
        fromDate: startOfDay(firstOfMonth).getTime(),
        toDate: now.getTime()
      };
    }
    case "7d": {
      const from = new Date(now);
      from.setDate(from.getDate() - 7);
      return {
        fromDate: from.getTime(),
        toDate: now.getTime()
      };
    }
    case "30d": {
      const from = new Date(now);
      from.setDate(from.getDate() - 30);
      return {
        fromDate: from.getTime(),
        toDate: now.getTime()
      };
    }
    default: {
      const from = new Date(now);
      from.setDate(from.getDate() - 7);
      return {
        fromDate: from.getTime(),
        toDate: now.getTime()
      };
    }
  }
};
